export const base_url = "https://www.commercialspc.com/admin/app/api";

export const router = {
    login: "/login",
    editUser: "/edit",
    register: "/register",
    forgotPwd: "/forgot",
    verifyOTP: "/confirm-code",
    resetPwd: "/reset",
    deleteAccount: "/delete-account",
    searchSpace: "/search-space-list",
    paymentToggle: "/is_payment",
    payment: "/payment",
    confirmPayment: "/confirm-payment",
    createSpace: "/create-space",
    viewSpaceList: "/view-space-list",
    viewSpaceDetails: "/view-space",
    deleteSpace: "/delete-space",
    getPropertyCount: "/space-by-property-type",
    getSpaceByCountry: "/space-by-continent",
    contactUs: "/contact-us",
    sendMessage: "/send-message",
}